import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Button, Form, Input, Select, Radio, Row, Col } from "antd";
import "./Form.css";

import {
  validateName,
  validateCellPhone,
  validateAddress,
  validateObservation,
  validateDni
} from "./validations";

import { departments } from "../../../locations";
import { relationshipList } from "../../../utils";

const { Option } = Select;
const { TextArea } = Input;

export const StepOne = ({ next, setDataFormClient, dataFormClient }) => {
  const querydb = getFirestore();

  const mapDocs = (res) => {
    return res.docs.map((ele) => ({ id: ele.id, ...ele.data() }));
  };

  const [clienttype, setClienttype] = useState();
  const [provinces, setProvinces] = useState();
  const [districts, setDistricts] = useState();
  const [managementtype, setManagementtype] = useState();
  const [channel, setChannel] = useState();
  const [salesclosingchannel, setSalesclosingchannel] = useState();
  const [delivery, setDelivery] = useState();
  const [deliveryValue,setDeliveryValue] = useState();
  const [aditionalContactName,setAditionalContactName] = useState();

  useEffect(() => {
    getDocs(collection(querydb, "channel")).then((res) => {
      setChannel(mapDocs(res));
    });
    getDocs(collection(querydb, "clienttype")).then((res) => {
      setClienttype(mapDocs(res));
    });
    getDocs(collection(querydb, "managementtype")).then((res) => {
      setManagementtype(mapDocs(res));
    });
    getDocs(collection(querydb, "salesclosingchannel")).then((res) => {
      setSalesclosingchannel(mapDocs(res));
    });
    getDocs(collection(querydb, "delivery")).then((res) => {
      setDelivery(mapDocs(res));
    });
  }, [querydb]);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    next();
    setDataFormClient({
      ...values,
      instagram: values.instagram ? values.instagram : "SIN CUENTA",
      customerName: values.customerName.toUpperCase(),
      clienttype: values.clienttype.toUpperCase(),
      department: values.department.toUpperCase(),
      province: values.province.toUpperCase(),
      district: values.district.toUpperCase(),
      address: values.address.toUpperCase(),
      reference: values.reference || "",
      managementtype: values.managementtype.toUpperCase(),
      delivery: values.delivery.toUpperCase(),
      channel: values.channel.toUpperCase(),
      salesclosingchannel: values.salesclosingchannel.toUpperCase(),
      dni: values.dni || "NO APLICA",
      aditionalContactName: values.aditionalContactName ? values.aditionalContactName.toUpperCase() : "NO APLICA",
      aditionalContactRelation: values.aditionalContactRelation ? values.aditionalContactRelation.toUpperCase() : "NO APLICA",
      aditionalContactPhone: values.aditionalContactRelation ? values.aditionalContactPhone.toUpperCase() : "NO APLICA"
    });
    form.resetFields();
  };

  const handleLocation = (values) => {
    if (values.department) {
      const department = departments.find(department => department.name === values.department);
      setProvinces(department.provinces);
    }

    if (values.province) {
      const selectedProvince = provinces.find(province => province.name === values.province);
      setDistricts(selectedProvince.districts);
    }

  }

  const handleDeliveryValue = (value) => {
    setDeliveryValue(value);
    if(value !== "Provincia"){
      form.setFieldValue("dni","");
    }
  }

  const handleAditionalContactName = (e) => {
    setAditionalContactName(e.target.value);
    console.log(aditionalContactName);
    if(!aditionalContactName){
      form.setFieldValue("aditionalContactRelation",null);
      form.setFieldValue("aditionalContactPhone",null);
    }
  }

  return (
    <Form
      form={form}
      name="control-hooks"
      onValuesChange={handleLocation}
      onFinish={onFinish}
      initialValues={dataFormClient}
    >
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="managementtype"
            label="Tipo de Gestión"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {managementtype &&
                managementtype?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="channel"
            label="Canal"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {channel &&
                channel?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="delivery"
            label="Entrega"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion" onSelect={handleDeliveryValue}>
              {delivery &&
                delivery?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="salesclosingchannel"
            label="Canal de Cierre de Venta"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Radio.Group>
              {salesclosingchannel &&
                salesclosingchannel?.map((storage, i) => {
                  return (
                    <Radio key={i} value={storage.name}>
                      {storage.name}
                    </Radio>
                  );
                })}
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {deliveryValue === "Provincia" ? <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
          name="dni"
          label="Dni"
          rules={[
            {
              required: true,
            },
            {
              validator:validateDni,
            }
          ]}
          >
            <Input maxLength={8}/>
          </Form.Item>
        </Col>
      </Row> : null }
      <h3 className="titles-form">Datos del Cliente</h3>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="customerName"
            label="Nombre de Cliente"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validateName
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="phoneNumber"
            label="Numero de celular "
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validateCellPhone
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>

      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="instagram"
            label="Cta de Instagram"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="clienttype"
            label="Tipo de Cliente"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Radio.Group>
              {clienttype &&
                clienttype?.map((storage, i) => {
                  return (
                    <Radio key={i} value={storage.value}>
                      {storage.name}
                    </Radio>
                  );
                })}
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="department"
            label="Departamento"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {departments.map((storage, i) => {
                return (
                  <Option
                    key={i}
                    value={storage.name}
                    label={storage.name}
                    name={storage.name}
                  >
                    {storage.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        {form.getFieldValue('department') ?
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="province"
              label="Provincia"
              rules={[
                {
                  required: true,
                  message: "Campo requerido",
                }
              ]}
            >
              <Select placeholder="Selecciona una opcion">
                {provinces && provinces.map((province, i) => {
                  return <Option
                    key={i}
                    value={province.name}
                    name={province.name}
                    label={province.name}
                  >{province.name}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          : null}
      </Row>
      <Row gutter={16}>
        {form.getFieldValue('province') ?
          <Col Col xs={24} sm={24} md={24} lg={12} >
            <Form.Item
              name="district"
              label="Distrito"
              rules={[
                {
                  required: true,
                  message: "Campo requerido"
                }
              ]}
            >
              <Select placeholder="Selecciona una opcion">
                {districts && districts.map((district, i) => {
                  return <Option
                    key={i}
                    value={district.name}
                    name={district.name}
                    label={district.name}
                  >{district.name}</Option>
                })}
              </Select>
            </Form.Item>
          </Col> : null
        }
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="address"
            label="Dirección"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validateAddress
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="reference"
            label="Referencia"
            rules={[
              {
                required: false,
              },
              {
                validator: validateObservation
              }
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
          name="aditionalContactName"
          label="Nombre contacto adicional"
          rules={[
            {
              required:false
            },
            {
              validator:validateName
            }
          ]}
          >
            <Input onChange={handleAditionalContactName}/>
          </Form.Item>
        </Col>
      </Row>
      {aditionalContactName ? <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
        <Form.Item
          name="aditionalContactRelation"
          label="Relacion"
          rules={[
            {
              required:true,
            }
          ]}
          >
            <Select>
              {Object.values(relationshipList).map((value,index) => <Option
              key={index}
              value={value}
              name={value}
              label={value}
              >{value}</Option>)}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="aditionalContactPhone"
            label="Telefono"
            rules={[
              {
                required: true,
              },
              {
                validator: validateCellPhone
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row> : null}
      <Form.Item className="container-buttons-formTwo">
        <Button type="primary" htmlType="submit" size="large">
          Siguiente
        </Button>
      </Form.Item>
    </Form>
  );
};
